export default __webpack_public_path__ + "static/media/pictogramBeaconPortfolio40.df3bade9.svg";